import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AppLayout from "../components/Layout/AppLayout";
import { isMfaChallengeToken } from "../utils/utils";

const PrivateRoute: React.FC = () => {
  const navigate = useNavigate();
  const storedToken: string | null = localStorage.getItem("authToken");
  // Defense-in-depth: an mfa_challenge-typed token should never end up in
  // authToken (it's handled via sessionStorage during the login flow), but
  // if one ever does, treat it as not-logged-in rather than trusting it -
  // the backend's UserMiddleware already rejects it too.
  const isLogged: string | null =
    storedToken && !isMfaChallengeToken(storedToken) ? storedToken : null;

  useEffect(() => {
    if (!isLogged) {
      navigate("/auth/login?logout=true");
    }
  }, [isLogged, navigate]);

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default PrivateRoute;
